import { render } from "./Agreement.vue?vue&type=template&id=d76f5252"
import script from "./Agreement.vue?vue&type=script&lang=js"
export * from "./Agreement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__